import { render } from "./Agents-page.vue?vue&type=template&id=702bd7ab&scoped=true"
import script from "./Agents-page.vue?vue&type=script&lang=js"
export * from "./Agents-page.vue?vue&type=script&lang=js"

import "./Agents-page.vue?vue&type=style&index=0&id=702bd7ab&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702bd7ab"]])

export default __exports__